/**
 * To toggle the filter part of the component
 *
 * @module views/components/FilterHeader
 * @memberof -Common
 */
import './FilterHeader.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import { spreadProps } from '@ulta/core/utils/dom/dom';

import { FILTER_GROUP_ID } from '@ulta/utils/constants/filters';


/**
 * Represents a FilterHeader component
 *
 * @method
 * @param {FilterHeaderProps} props - React properties passed from composition
 * @returns FilterHeader
 */

export const FilterHeader = function( props ){
  const loading = false;
  const {
    filterbuttonLabel,
    filterbuttonArialabel,
    onFilterClick,
    ariaExpanded,
    search,
    isMobileDevice,
    showFiltersButtonRef,
    isStoreChecked,
    isSelectedStore,
    iconImage,
    filterByStorePill
  } = props;
  // Prop check
  if( !onFilterClick ){
    return null;
  }

  const isSelectedStoreOnMobile = isSelectedStore && isStoreChecked && isMobileDevice && filterByStorePill;
  const label = isSelectedStoreOnMobile ? '' : filterbuttonLabel;

  return (
    <div className='FilterHeader'>
      <div
        className={ classNames( 'FilterHeader__filterbutton', {
          FilterHeader__filterbutton__isSearchResult: search || isMobileDevice
        } ) }
      >
        <Button
          className={ classNames( 'FilterHeader__button', {
            FilterHeader__button__isMobile: isSelectedStoreOnMobile
          } ) }
          label={ label }
          iconImage={ iconImage }
          { ...spreadProps( {
            iconSize: isSelectedStoreOnMobile ? 'lg' : undefined
          } ) }
          variant='unstyled'
          disabled={ loading }
          ariaLabel={ filterbuttonArialabel }
          ariaHiddenIcon={ true }
          onClick={ onFilterClick }
          isExpanded={ ariaExpanded }
          ref={ showFiltersButtonRef }
          ariaControls={ FILTER_GROUP_ID }
        />
      </div>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef FilterHeaderProps
 * @type {object}
 * @property { string } filterbuttonLabel - sets the label for the filter button
 * @property { string } filterbuttonArialabel - sets the aria label for the filter button
 * @property { boolean } ariaExpanded - sets the aria-expanded for the filter button
 * @property { string } search - get the value of search filter category
 * @property { object } showFiltersButtonRef - showFiltersButtonRef
 * @property { object } isSelectedStore - selected store information
 * @property { string } iconImage - icon image svg
 * @property { object } filterByStorePill - ilter by store pills
 */
export const propTypes = {
  /** sets the label for the filter button */
  filterbuttonLabel: PropTypes.string,
  /** sets the aria label for the filter button  */
  filterbuttonArialabel: PropTypes.string,
  /** Onclick function  */
  onFilterClick: PropTypes.func,
  /** aria-expanded property  */
  ariaExpanded: PropTypes.bool,
  /** set filter category value  */
  search: PropTypes.string,
  /** check current device  */
  isMobileDevice: PropTypes.bool,
  /** flyout opener ref */
  showFiltersButtonRef: PropTypes.object,
  /** selected store information */
  isSelectedStore: PropTypes.object,
  /** icon image svg */
  iconImage: PropTypes.string,
  /** filter by store pills */
  filterByStorePill: PropTypes.object
};

FilterHeader.propTypes = propTypes;

export default FilterHeader;
